<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="missionId"
            search-url="/kidMission/listAll"
            create-url="/kidMission/save"
            delete-url="/kidMission/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete=acceptDelete
            :acceptView=false
            :accept-create="false"
            :accept-edit=acceptEdit
            @viewItem="viewItem"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/mission/MissionCreate";
import {message} from "@/shared/message";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách nhiệm vụ",
      formCreateName: "Thêm mới nhiệm vụ",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      acceptDelete: false,
      acceptEdit:false,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          sortable: false,
          headerStyle: "text-align:center; width: 80px;",
        },
        {
          value: 'missionName',
          text: 'Tên nhiệm vụ',
          sortable: false,
          headerStyle: "text-align:center; width: 100px;",
          search: true,
        },
        {
          value: 'programId',
          text: 'Khung chương trình',
          headerStyle: "text-align:center; width: 150px;",
          sortable: false,
          search: true,
          type: "select",
          name: "programId",
          items: [],
          itemText: "programName",
          itemValue: "programId",
        },
        {
          value: 'descriptionMonday',
          text: 'Nội dung nhiệm vụ thứ 2',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },
       /* {
          value: 'descriptionTuesday',
          text: 'Nội dung nhiệm vụ thứ 3',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },
        {
          value: 'descriptionWednesday',
          text: 'Nội dung nhiệm vụ thứ 4',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },*/
        {
          value: 'descriptionThursday',
          text: 'Nội dung nhiệm vụ thứ 5',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },
        /*{
          value: 'descriptionFriday',
          text: 'Nội dung nhiệm vụ thứ 6',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },
        {
          value: 'descriptionSaturday',
          text: 'Nội dung nhiệm vụ thứ 7',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },*/
/*        {
          value: 'descriptionSunday',
          text: 'Nội dung nhiệm vụ chủ nhật',
          sortable: false,
          search: false,
          headerStyle: "text-align:center; width: 200px;",
        },*/
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          headerStyle: "text-align:center; width: 150px;",
        },
      ],
    };
  },

  created() {

    axios.post(
        process.env.VUE_APP_API_URL + "/kidMission/getUsers", {status: 1}
    )
        .then(
            (data) => {
              if (data.success) {
                this.acceptDelete = true,
                    this.acceptEdit = true
              } else {
                this.acceptDelete = false,
                    this.acceptEdit = false
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới nhiệm vụ';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật nhiệm vụ';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
  },

  destroyed() {
  },
};
</script>
